var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { uuidv4 } from '../../common/utils';
import Channel from './Channel';
/**
 * Enter channels to express yourself, such as personal blog, YouTube, etc.
 *
 * @props channels: Enter the props of the channel components as an array of objects. Please check to the following. {@link https://github.com/modern-agile-team/dev-portfolio#channel}
 *
 * @example channels
 * ```js
  [{ redirectUrl: '/', name: 'github', color: 'black', size: '24px', margin: '0px 6px', padding: '0px' }, { redirectUrl: '/', name: 'youtube', color: '#e03b35', size: '24px', margin: '0px 6px', padding: '0px' }, { redirectUrl: '/', name: 'linkedin', color: '#1295cd', size: '24px', margin: '0px 6px', padding: '0px' }]
 ```
 */
var Channels = function (_a) {
    var channels = _a.channels;
    return (_jsx(Container, { children: channels === null || channels === void 0 ? void 0 : channels.map(function (_a) {
            var redirectUrl = _a.redirectUrl, name = _a.name, color = _a.color, size = _a.size, margin = _a.margin;
            return (_jsx(Channel, { redirectUrl: redirectUrl, name: name, color: color, size: size, margin: margin }, uuidv4()));
        }) }));
};
export default Channels;
Channels.defaultProps = {
    channels: [
        {
            redirectUrl: '/',
            name: 'github',
            color: 'black',
            size: '24px',
            margin: '0px 6px',
            padding: '0px',
        },
        {
            redirectUrl: '/',
            name: 'youtube',
            color: '#e03b35',
            size: '24px',
            margin: '0px 6px',
            padding: '0px',
        },
        {
            redirectUrl: '/',
            name: 'linkedin',
            color: '#1295cd',
            size: '24px',
            margin: '0px 6px',
            padding: '0px',
        },
    ],
};
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  @media screen and (max-width: 374px) {\n    display: none;\n  }\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  @media screen and (max-width: 374px) {\n    display: none;\n  }\n"])));
var templateObject_1;
